/* DON'T EDIT THIS FILE: edit original and run build again */ import { Roles } from "../../framework/permission/schema.ts";
import { PermissionCollection } from "../../framework/permission/types.ts";
import {
  canAssignHelpersToAnAssignee,
  canBeAssignedAsHelperToAnAssignee,
} from "./permissions.ts";

const helpersPermissions: PermissionCollection = {
  namespace: "helpers",
  permissions: [
    {
      name: canBeAssignedAsHelperToAnAssignee,
      description:
        "Puede ser asignado como asistente comercial de un EndClient",
      roles: [Roles.sales],
    },
    {
      name: canAssignHelpersToAnAssignee,
      description: "Puede asignar asistentes comerciales a un EndClient",
      roles: [Roles.admin, Roles.tenantAdmin, Roles.salesManager],
    },
  ],
};

export default helpersPermissions;
